<template>
    <v-textarea
        :value="localValue"
        :label="label"
        :placeholder="placeholder"
        :hint="hint"
        :persistent-hint="persistentHint"
        :outline="outline"
        :hide-details="hideDetails"
        :auto-grow="autoGrow"
        :rows="rows"
        :autofocus="autofocus"
        :class="textareaClass"
        @input="onLocalInput"
    ></v-textarea>
</template>

<script>
export default {
    name: "IsolatedTextarea",
    props: {
        value: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "",
        },
        placeholder: {
            type: String,
            default: "",
        },
        hint: {
            type: String,
            default: "",
        },
        persistentHint: {
            type: Boolean,
            default: false,
        },
        outline: {
            type: Boolean,
            default: false,
        },
        hideDetails: {
            type: Boolean,
            default: false,
        },
        autoGrow: {
            type: Boolean,
            default: false,
        },
        rows: {
            type: [Number, String],
            default: 3,
        },
        autofocus: {
            type: Boolean,
            default: false,
        },
        textareaClass: {
            type: String,
            default: "",
        },
    },
    data: function() {
        return {
            localValue: this.value || "",
            hadText: !!(this.value && String(this.value).trim()),
        };
    },
    watch: {
        value: function(val) {
            var next = val || "";
            if (next !== this.localValue) {
                this.localValue = next;
                this.emitHasText();
            }
        },
    },
    mounted: function() {
        this.hadText = !!(this.localValue && String(this.localValue).trim());
        this.$emit("has-text", this.hadText);
    },
    methods: {
        getValue: function() {
            return this.localValue || "";
        },
        onLocalInput: function(val) {
            var next = val;
            if (val && typeof val === "object" && val.target) {
                next = val.target.value;
            }
            this.localValue = next == null ? "" : next;
            this.emitHasText();
        },
        emitHasText: function() {
            var has = !!(this.localValue && String(this.localValue).trim());
            if (has !== this.hadText) {
                this.hadText = has;
                this.$emit("has-text", has);
            }
        },
    },
};
</script>
